<template>
    <h2 class="mt-0">Alert Banners</h2>
    <fieldset class="mb-4 grid gap-4 border px-4 py-2">
        <legend>Custom banner copy</legend>
        <div class="grid">
            <label for="title-msg">Title</label>
            <input
                v-model="titleMsg"
                id="title-msg"
                class="rounded-sm"
                type="text"
            />

            <label
                class="pt-2"
                for="body-msg"
                >Body</label
            >
            <textarea
                v-model="bodyMsg"
                id="body-msg"
                class="resize-y rounded-sm"
            ></textarea>
        </div>
    </fieldset>

    <h3>Warning</h3>
    <DsAlertBanner
        class="mb-2"
        :title="titleMsg || 'Warning Banner'"
        variant="warning"
    />
    <DsAlertBanner
        :title="titleMsg || 'Warning Banner'"
        variant="warning"
    >
        {{ bodyMsg || 'This text is optional and adds more context to banner title. Text wraps, never truncates.' }}
    </DsAlertBanner>

    <h3>Error</h3>
    <DsAlertBanner
        class="mb-2"
        :title="titleMsg || 'Error Banner'"
        variant="error"
    />
    <DsAlertBanner
        :title="titleMsg || 'Error Banner'"
        variant="error"
    >
        {{ bodyMsg || 'This text is optional and adds more context to banner title. Text wraps, never truncates.' }}
    </DsAlertBanner>

    <h3>Info</h3>
    <DsAlertBanner
        class="mb-2"
        :title="titleMsg || 'Info Banner'"
        variant="info"
    />
    <DsAlertBanner
        :title="titleMsg || 'Info Banner'"
        variant="info"
    >
        {{ bodyMsg || 'This text is optional and adds more context to banner title. Text wraps, never truncates.' }}
    </DsAlertBanner>
</template>

<script setup lang="ts">
import DsAlertBanner from '@ds/alert-banner/DsAlertBanner.vue';
import { ref } from 'vue';

const titleMsg = ref('');
const bodyMsg = ref('');
</script>

<style lang="scss" scoped>
h2,
h3 {
    @apply my-4;
}
</style>
